import { SchematicMap } from "@/components/guide/SchematicMap";
import { regionLetter } from "@/lib/content";
import type { GuideData } from "@/types/content";
import type { SchoolId } from "@/types/navigation";

const DOT_COLORS = ["#1E3A35", "#9A552F", "#8C7242"];

type Section2RegionsProps = {
  schoolId: SchoolId;
  guide: GuideData;
};

export function Section2Regions({ schoolId, guide }: Section2RegionsProps) {
  return (
    <section className="border-y border-[var(--line)] bg-paper-warm px-5 py-8">
      <p className="kicker mb-3">第二段 · 心里有个谱</p>
      <h2 className="font-serif text-[22px] font-medium leading-snug text-ink-900">
        三个片区,在地图上的位置。
      </h2>
      <p className="mb-5 mt-1 text-[13px] leading-relaxed text-ink-600">
        现在不用选,先大概看一眼。
      </p>

      <SchematicMap schoolId={schoolId} guide={guide} />

      <div className="mt-5 overflow-hidden rounded-lg border border-[var(--line)] bg-paper">
        {guide.regions.map((r, i) => (
          <div
            key={r.id}
            className={`flex items-start gap-3 px-4 py-3.5 ${
              i < guide.regions.length - 1 ? "border-b border-[var(--line-soft)]" : ""
            }`}
          >
            <div
              className="mt-0.5 flex h-[22px] w-[22px] shrink-0 items-center justify-center rounded-full font-mono text-[10px] font-semibold text-paper"
              style={{ background: DOT_COLORS[i] ?? DOT_COLORS[0] }}
            >
              {regionLetter(i)}
            </div>
            <div className="min-w-0 flex-1">
              <div className="flex items-start justify-between gap-2">
                <div className="min-w-0 flex-1">
                  <p className="text-sm font-medium leading-snug text-ink-900">{r.nameCn}</p>
                  <p className="mt-0.5 font-mono text-[11px] leading-snug text-ink-400">{r.nameEn}</p>
                </div>
                <p className="hidden shrink-0 whitespace-nowrap text-right font-mono text-[11.5px] tabular-nums text-ink-700 xs:block">
                  {r.priceText}
                </p>
              </div>
              <p className="mt-0.5 text-[11.5px] text-ink-400">
                {r.distance} · {r.type}
              </p>
              <p className="mt-1 font-mono text-[11.5px] tabular-nums text-ink-700 xs:hidden">
                {r.priceText}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
